import { createGlobalStyle } from 'styled-components'

export const AboutStyle = createGlobalStyle`
.About {
  height: 100vh;
}
`